import Int32LookupRequestModel from '../../generated/types/model/resource/Int32LookupRequestModel';

export default class Int32LookupRequestViewModel extends Int32LookupRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
